<template>
	<div>
		<buttonList :buttonList="list" butWidth="200px" v-if="!isFold"></buttonList>
		<iconList :list="list" v-else></iconList>
		<moveGarbage
			:conv_visible.sync="movevisible"
			:getDetailsData="clueData"
			@change="changeGarbageFlag"
			v-bind="$attrs"
		></moveGarbage>
		<transfer
			:visible.sync="visible"
			:getDetailsData="trans"
			v-on="$listeners"
			v-bind="$attrs"
		></transfer>
		<notRubbish
			:msgVisible.sync="notRub_visible"
			:getDetailsData="notRub"
			@change="changeGarbageFlag"
			v-bind="$attrs"
		></notRubbish>
	</div>
</template>

<script>
import iconList from '@/components/chat/components/iconList.vue';
import buttonList from '@/components/chat/buttonList.vue';
import moveGarbage from '@/components/crm/clue/buttonOperation/moveGarbage.vue';
import transfer from '@/components/crm/clue/buttonOperation/transfer.vue';
import notRubbish from '@/components/crm/clue/buttonOperation/notRubbish.vue';
import clueSer from '@/client/services/clue/clueSer.js';
import chatSer from '@/backend/services/chat/chatSer.js';
export default {
	props: {
		isFold: {
			type: Boolean,
			default: false,
		},
		tableId: {
			type: String, //询盘id
		},
		id:{
			type: String, 
		}
	},
	data() {
		return {
			movevisible: false,
			visible: false,
			notRub_visible: false,
			list: [],
			clueData: {
				summaryId: '',
				email: '',
			},
			trans: {
				summaryId: '',
				userName: '',
			},
			notRub: {
				id: '472120462982250496',
				inquiryType: 6,
				websiteType: 6,
			},
			garbageFlag: 0,
			source: 0,
		};
	},

	components: { buttonList, iconList, moveGarbage, transfer, notRubbish },

	computed: {},
	watch: {
		tableId: {
			handler(val) {
				if (val && val != '0') {
					this.getclueInfo();
					this.getData1();
				}
			},
			immediate: true,
			deep: true,
		},
		garbageFlag: {
			handler(val) {
				if (val == 1) {
					this.list = [
						{
							text: '这不是垃圾',
							imgsrc: require('@/assets/chat/no-rub.png'),
							onClick: () => {
								this.notRub_visible = true;
							},
						},
						// {
						// 	text: '线索详情',
						// 	onClick: () => {
						// 		this.skip();
						// 	},
						// },
					];
				} else {
					this.list = [
						{
							text: '线索转移',
							imgsrc: require('@/assets/chat/clue_trans.png'),
							onClick: () => {
								this.visible = true;
							},
						},
						{
							text: '移入垃圾池',
							imgsrc: require('@/assets/chat/move_garbage_pool.png'),
							onClick: () => {
								this.movevisible = true;
							},
						},
						{
							text: '线索详情',
							imgsrc: require('@/assets/chat/clue_d.png'),
							onClick: () => {
								this.skip();
							},
						},
					];
				}
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		async getclueInfo() {
			const res = await clueSer.clueDetails({
				id: this.tableId,
				inquiryType: 5,
			});
			this.trans = {
				summaryId: res.data.summaryId,
				userName: res.data.name,
			};
			this.clueData = {
				summaryId: res.data.summaryId,
				email: res.data.email,
			};
			this.notRub = res.data;
		},
		changeGarbageFlag(val) {
			this.garbageFlag = val;
		},
		async getData1() {
			let res = await chatSer.headerDetail({
				id: this.id,
				type: 1,
			});
			this.garbageFlag = res.data.garbageFlag; //类型为线索(垃圾询盘(0:否;1:是;));类型为客户(是否公海客户(0:否;1:是;))
			this.source = res.data.source; //来源(0:全部;1:我的;)
		},
		skip() {
			if (this.garbageFlag == 1) {
				this.$router.push({
					name: 'garbageClue',
					query: {
						id: this.notRub.tableId,
						summaryId: this.notRub.summaryId,
						inquiryType: this.notRub.inquiryType,
						type: 3, // 0 全部线索  1 线索列表详情  3 垃圾线索
						messengerType: 1,
					},
				});
			} else {
				this.$router.push({
					name: this.source == 0 ? 'clueDetails_all' : 'clueDetails',
					query: {
						id: this.notRub.tableId,
						summaryId: this.notRub.summaryId,
						inquiryType: this.notRub.inquiryType,
						type: this.source == 0 ? 0 : 1, // 0 全部线索  1 线索列表详情  3 垃圾线索
						messengerType: 1,
					},
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
